module.exports = __webpack_public_path__ + "img/probiotic-1.7a507d66.png";